import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              LET ME <span className="purple"> INTRODUCE </span> MYSELF
            </h1>
            <p className="home-about-body">
              My journey into programming began with a fascination for how drones are made.
              That curiosity led me to explore the world of technology, and unexpectedly,
              I found myself deep-diving into web development after securing a surprising
              internship opportunity. Since then, I've been passionately coding, building,
              and refining my skills.
              <br />
              <br />I am proficient in
              <i>
                <b className="purple"> Python, JavaScript, and the Django Framework. </b>
              </i>
              <br />
              <br />My field of interest includes developing scalable
              <i>
                <b className="purple"> Web Technologies and Products</b>
              </i>
              &nbsp; and exploring cloud-based solutions with
              <b className="purple"> AWS EC2.</b>
              <br />
              <br />
              Whenever possible, I love implementing my passion for development using
              <i>
                <b className="purple"> Modern JavaScript Frameworks</b>
              </i>
              &nbsp; like
              <i>
                <b className="purple"> React.js</b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>FIND ME ON</h1>
            <p>
              Feel free to <span className="purple">connect </span>with me
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/Amitabhraj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/AmitabhRaj"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default Home2;
